export default __webpack_public_path__ + "static/media/luxemburg.d39cf513.jpg";